module.exports = {
      id: "messenger-usage",
      viewBox: "0 0 28 28",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#messenger",
      toString: function () {
        return this.url;
      }
    }